import { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import Navbar from "../components/layout/Navbar";
import Footer from "../components/layout/Footer";
import { api, errorMessage } from "../lib/api";
import { CheckCircle, X } from "@phosphor-icons/react";

export default function VerifyEmail() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const [state, setState] = useState({ status: "loading", message: "" });
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        if (!token) {
            setState({ status: "error", message: "Missing verification token." });
            return;
        }
        api.post("/auth/verify-email", { token })
            .then(() => setState({ status: "ok", message: "Email verified. You can close this tab." }))
            .catch((e) => setState({ status: "error", message: errorMessage(e) }));
    }, [token]);

    return (
        <div className="bg-paper min-h-screen flex flex-col">
            <Navbar />
            <div className="flex-1 max-w-xl mx-auto px-6 py-24 text-center">
                {state.status === "loading" && (
                    <p className="font-mono text-xs text-ink-600" data-testid="verify-loading">VERIFYING…</p>
                )}
                {state.status === "ok" && (
                    <>
                        <CheckCircle size={56} weight="fill" className="text-success mx-auto mb-6" />
                        <h1 className="h2 mb-3" data-testid="verify-success">Email verified.</h1>
                        <p className="text-ink-600 text-sm">{state.message}</p>
                    </>
                )}
                {state.status === "error" && (
                    <>
                        <X size={56} className="text-error mx-auto mb-6" />
                        <h1 className="h2 mb-3" data-testid="verify-error">Verification failed</h1>
                        <p className="text-ink-600 text-sm">{state.message}</p>
                        <Link to="/login" className="btn btn-outline mt-6">Back to login</Link>
                    </>
                )}
            </div>
            <Footer />
        </div>
    );
}
